import organization from '@/http/requests/organization'
import { parseRequestError } from '@/helpers/helpers'

export default {
  fetchOrganizationConfig: ({ commit }) => new Promise((resolve, reject) => {
    organization.getOrganizationConfig()
      .then(response => {
        commit('SET_ORGANIZATION_CONFIG', response.data)
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  patchOrganizationConfig: ({ commit }, { path, value }) => new Promise((resolve, reject) => {
    organization.patchOrganizationConfig(path, value)
      .then(response => {
        commit('UPDATE_ORGANIZATION_CONFIG_VALUE', { path, value })
        resolve(response)
      })
      .catch(error => {
        parseRequestError(error)
        reject(error)
      })
  }),
}
